var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OffCanvasMenu',{ref:"menu",on:{"overlay-clicked":_vm.close}},[_c('ErrorBoundary',[(_vm.loading)?_c('ActivityOverlay'):_vm._e(),_vm._v(" "),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }